import { NotificationPosition } from 'core/enums';
import { Notification } from 'coreOld/components';
import { Icon } from 'coreOld/elements';

import {
  CloseButton,
  SubtitleModal,
  TitleModal,
  WrapTop,
  Wrapper,
} from './modalHorizontalHeaderStyle';

interface IProps {
  title: string;
  subtitle?: string | JSX.Element;
  logoPath?: string;
  closeModal: (reset) => void;
  hasContent?: boolean;
  flex?: number;
  height?: number;
}

const ModalHorizontalHeaderView = ({
  title,
  subtitle,
  closeModal,
  hasContent,
  flex,
  height,
}: IProps) => {
  return (
    <Wrapper noContent={!hasContent} flex={flex} height={height}>
      <WrapTop>
        <CloseButton type="button" onClick={closeModal}>
          <Icon name={Icon.CLOSE} />
        </CloseButton>
      </WrapTop>

      <TitleModal>{title}</TitleModal>

      <SubtitleModal>{subtitle}</SubtitleModal>

      <Notification position={NotificationPosition.MODAL} />
    </Wrapper>
  );
};

export default ModalHorizontalHeaderView;
